angular.module('picmonicng').filter('blueWords', function () {
  return function (input) {
    if (!input) {
      return input;
    }

    s = input.replace(/&nbsp/g, '');
    s = s.replace(/[^\w\s-]/g, '').trim();

    return s.replace(/[-\s]+/g, '-');
  };
});
